import axios from 'axios';
import React from 'react'

export function GetUsuarios(callback){
  axios.get('/api/Administracion/Usuarios/Listado').then((obj) => {
    callback(obj);
  }).catch(e => console.error(e))
}

export function GetUsuariosCsv() {
  axios({
      url: '/api/Administracion/Usuarios/DescargarCsv', // Tu endpoint
      method: 'GET',
      responseType: 'blob', // Importante para manejar la respuesta como archivo binario
  }).then((response) => {
      // Intentar obtener el nombre del archivo desde la cabecera Content-Disposition
      const headerLine = response.headers ? response.headers['content-disposition'] : undefined; // Acceso seguro
      let filename = 'usuarios_dte.csv'; // Nombre por defecto
      if (headerLine) {
          const filenameMatch = headerLine.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
          if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
          }
      }

      // Crear un Blob del response
      const url = window.URL.createObjectURL(new Blob([response], { type: 'text/csv' })); // Especifica el tipo MIME correcto

      // Crear un link temporal para iniciar la descarga
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Establecer el nombre del archivo
      document.body.appendChild(link);
      link.click(); // Simular click para descargar

      // Limpiar el link y el objeto URL
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

  }).catch(error => {
      console.error("Error al descargar el archivo CSV:", error);
      // Mostrar un mensaje de error más amigable
      let mensajeError = "Ocurrió un error al descargar el archivo.";
      if (error.response) {
          // Intentar leer un mensaje de error si el backend lo envía como JSON en el blob
          // Esto es un poco más complejo porque la respuesta es un blob
           const reader = new FileReader();
           reader.onload = function() {
               try {
                  const errorJson = JSON.parse(reader.result);
                  if(errorJson && errorJson.message) {
                      mensajeError = errorJson.message;
                  } else if (errorJson && errorJson.title) {
                      mensajeError = errorJson.title;
                  }
               } catch (e) {
                  // No era JSON, usar mensaje genérico
               }
               console.error("Error", mensajeError, "error");
           }
           reader.onerror = function() {
               console.error("Error", mensajeError, "error");
           }
           reader.readAsText(error.response.data); // Intentar leer el blob como texto
      } else {
          console.error("Error", mensajeError, "error");
      }
  });
}

export function GetPerfiles(callback){
  axios.get('/api/Administracion/Perfiles/Listado').then((obj) => {
    callback(obj);
  }).catch(e => console.error(e))
}

export function SetPermisos(d,callback){
  axios.post('/api/Administracion/Perfil/{id}/Permisos',d).then((obj) => {
    callback(obj);
  }).catch(e => console.error(e))
}

export function GetFoliacionAutomatica(callback){
  axios.get('/api/Administracion/Folio/Automatico').then((obj) => {
    callback(obj);
  }).catch(e => console.error(e))
}

export function SetFoliacionAutomatica(datos,callback){
  axios.post('/api/Administracion/Folio/Automatico',datos).then((obj) => {
    callback(obj);
  }).catch(e => console.error(e))
}

export function GetFolios(callback) {
  axios({
      method: 'get',
      url: '/api/Administracion/Folio'
    }).then((obj) => {
      callback(obj);
    }).catch(e => console.error(e))
}

export function GetProximo(callback) {
  axios({
      method: 'get',
      url: '/api/Administracion/Folio/Proximo'
    }).then((obj) => {
      callback(obj);
    }).catch(e => console.error(e))
}

export function SetFoliaDesde(tipo,valor,callback) {
  axios.post("/api/Administracion/Folio/FoliaDesde",{tipo,valor}).then(o => {
      callback(o);
    }).catch(e=>callback(e))
}

export function GetDatosCorreo(callback) {
  axios({
    method: 'get',
    url: '/api/Administracion/Correo'
  }).then((obj) => {
    callback(obj);
  }).catch(e => console.error(e))
}

export function GuardarDatosCorreo(datos, callback) {
  axios.post('/api/Administracion/Correo/Guardar', datos).then(()=> {
    callback();
  }).catch((e)=> {
      /*alert(e.response.data.Mensaje)*/;
  })
}

export function GetCertificados(callback) {
  axios.get('/api/Administracion/Remitentes').then((remitentes)=> {
    callback(remitentes);
  }).catch((e)=> {
      /*alert(e.response.data.Mensaje)*/;
  })
}

export function EliminaCertificado(id,callback) {
  axios.post('/api/Administracion/Remitente/Eliminar/'+id).then((ok)=> {
      callback();
  }).catch((e)=> {
      /*alert(e.response.data.Mensaje)*/;
  })
}

export function VerificaCertificado(id, callback, errorCallback) {
  axios.post('/api/Administracion/Remitente/Verificar/' + id).then((res) => {
    if (callback) callback(res.data || res);
  }).catch((e) => {
    if (errorCallback) errorCallback(e);
  });
}

export function EstableceRemitenteDefecto(id, callback) {
  axios.post('/api/Administracion/Remitente/EstablecerDefecto/' + id).then((ok) => {
    if (callback) callback();
  }).catch((e) => {
    console.error(e);
  });
}

export function GetPlantillas(dispatch) {
  axios.get("/api/imprimir/listado").then(listado => {
    dispatch({ type: "plantillasListado", listado });
  }).catch(e => console.error(e))
}

export function GetApiKeys(dispatch) {
    axios.get("/api/cuenta/apikey/listado").then(listado => {
      dispatch({ type: "apiKeyListado", listado });
    }).catch(e => console.error(e))
}


export function GetReglas(dispatch) {
  axios.get("/api/administracion/reglas").then(listado => {
    dispatch({ type: "reglasListado", listado });
  }).catch(e => console.error(e))
}

export function GetEmpresas(dispatch) {
  axios.get("/api/administracion/empresas/listado").then(listado => {
    dispatch({ type: "empresasListado", listado });
  }).catch(e => console.error(e))
}

export function DropApiKey(dispatch,claves){
  axios.post("/api/cuenta/apikey/desactivar",{claves}).then(o => {
    GetApiKeys(dispatch)
  }).catch(e => console.error(e))
}

export function AddApiKey(ldispatch,adispatch,dias){
  axios.post("/api/cuenta/apikey",{dias}).then(o => {
    ldispatch({
      type: "setAlert", Alert: {
          sinAccion: true,
          titulo: "Su nueva Api Key: "+o.ID,
          contenido: <div>
            <p>Su nueva Api Key es</p>
            <p><strong>{o.Token}</strong></p>
            <p>Guarde este código. No lo podrá rescatar después.</p>
          </div>
      }
    })
    GetApiKeys(adispatch)
  }).catch(e => console.error(e))
}